<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Ingredients</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Ingredients
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <button @click.prevent="addIngredientModal" data-toggle="modal" data-target="#faq-modal"
                        type="button"
                        class="btn btn-outline-primary float-md-right"><i class="feather icon-plus icon-left"></i>
                    Add Ingredients
                </button>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Ingredients</h4>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="ingredient-search"
                        placeholder="Search by name or description"
                    />
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allIngredients"
                        ref="myTable"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#"
                                   class="dropdown-item"
                                   @click.prevent="editIngredientModal(props.row.name, props.row.description, props.row.id )">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </a>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>

        <div class="modal fade add-ingredient-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="addIngredient">
                        <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">
                            {{ this.isEditing ? "Edit" : "Add" }} Ingredients</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Ingredient Name</label>
                                <input type="text" required="required" v-model="ingredient.name"
                                       class="form-control">
                                <div v-if="ingredient.errors.name" class="text-danger text-small">
                                    {{ ingredient.errors.name }}
                                </div>
                            </div>

                            <div class="form-group"><label>Ingredient Description</label>
                                <textarea required="required" v-model="ingredient.description"
                                          class="form-control" cols="30" rows="10"></textarea>
                                <div v-if="ingredient.errors.description" class="text-danger text-small">
                                    {{ ingredient.errors.description }}
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../../../Shared/Mixins/ListQueryMixin";

export default {
    metaInfo: {title: 'Ingredients'},
    props: [
        'ingredients',
    ],
    layout: Layout,
    components: {
        Link,
        ListControls,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        ListQueryMixin,
    ],
    data() {
        return {
            ingredient: this.$inertia.form({
                name: null,
                description: null,
                id: null,
            }),
            filter: {},
            isLoadingFilter: false,
            allIngredients: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },

            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Ingredients Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Ingredient Description',
                    field: 'description',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Ingredient Slug',
                    field: 'slug',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {label: 'Action', field: 'action', sortable: false, thClass: 'text-center', tdClass: 'text-center'},
            ],
            tableDataLoading: false,
            saving: false,
            isEditing: false,
        }
    },

    mounted() {
        this.allIngredients = this.ingredients.data;
        this.totalRecords = this.ingredients.total
    },

    methods: {

        addIngredientModal() {
            $('.add-ingredient-modal').modal('show');
            this.ingredient.name = ""
            this.ingredient.description = "";
            this.isEditing = false;
        },

        async editIngredientModal(name, description, resourceId) {
            this.ingredient.topping_name = name;
            this.ingredient.description = description;
            this.isEditing = true;
            this.ingredient.id = resourceId
            $('.add-ingredient-modal').modal('show');
        },

        async addIngredient(id = null) {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('.add-ingredient-modal').modal('hide');

                },
                onError: () => {
                    this.saving = false;
                }
            };
            this.isEditing ?
                this.ingredient.put(route('admin.categories.ingredients.update', this.ingredient.id), options)
                :
                this.ingredient.post(route('admin.categories.ingredients.store'), options);

            await this.paginatedData();
        },

        paginatedData() {
            return this.loadList('admin.categories.ingredients.index', 'allIngredients');
        },
        async deleteIngredient(id) {
            await this.$inertia.delete(route('admin.categories.ingredients.delete', id), {
                preserveScroll: true,
                onSuccess: async() => {
                    await this.paginatedData();
                }
            })
        },
        async showAlert(ingredientId) {
            const details = {
                title: "Are you sure you want to delete this ingredient?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteIngredient(ingredientId) : "";
        },
    }
}
</script>
